import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'contact',
  label: 'Contact Section',
  description: 'Two-column contact page with form and info panel.',
  supportedPages: ['contact'],
  variants: [{ id: 'v1', label: 'V1 (Split Layout)' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string' },
    { key: 'description', label: 'Description', type: 'text' },
    { key: 'email', label: 'Email Address', type: 'string' },
    { key: 'phone', label: 'Phone Number', type: 'string' },
    { key: 'address', label: 'Physical Address', type: 'text' },
  ],
}
